import { OnboardingDocumentsItemStatusEnum } from 'commons/types/DTO/bank/applications/manage/OnboardingDocumentsItem'
import { TextBadge } from 'ui/components'

type Props = {
  status: OnboardingDocumentsItemStatusEnum
}

export const StatusBadge = (props: Props) => {
  const { status } = props

  switch (status.toLocaleLowerCase()) {
    case OnboardingDocumentsItemStatusEnum.CREATED:
      return <TextBadge color={'warning'}>{status}</TextBadge>
    case OnboardingDocumentsItemStatusEnum.SIGNED:
      return <TextBadge color={'positive'}>{status}</TextBadge>
    default:
      return <TextBadge color={'default'}>{status}</TextBadge>
  }
}
